import {get} from 'lodash';

export default (state = {}, {coachId, rankId, progression}: any) => {
  return {
    ...state,
    rankProgressions: {
      ...get(state, 'rankProgressions', {}),
      [`${coachId}->${rankId}`]: progression,
    },
  };
};
